export const PrewArrow = () => (
  <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.86133 1.72031L1.51467 6.06695C1.00133 6.58028 1.00133 7.42028 1.51467 7.93361L5.86133 12.2803" stroke="white" style={{ stroke: 'white', strokeOpacity: 1 }} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);